<template>
  <v-card class="ma-4 d-flex justify-center" id="call-status">
    <chart
      type="pie"
      id="call-status-chart"
      :data="_chart.data"
      :title="_chart.title"
      :labels="_chart.labels"
      height="500"
      elevation="0"
      width="500"
    />
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex';
import Chart from '@/components/charts/Chart';

export default {
  components: {
    Chart,
  },
  computed: {
    ...mapGetters({
      _chart: 'reconciliation/getCallStatusChart',
    }),
  },
};
</script>
